import { useMemo } from "react";
import useDevice from "src/hooks/useDevice";
import { basicFont, largeFont, xlFont } from "src/styles/fonts";

const useGatheringNameFontSize = (gatheringName: string | null | undefined) => {
	const { device } = useDevice();

	const fontSize = useMemo(() => {
		if (device === "desktop") return xlFont.fontSize;
		if (!gatheringName) return xlFont.fontSize;
		if (gatheringName.length < 10) return xlFont.fontSize;
		if (gatheringName.length < 20) return largeFont.fontSize;
		return basicFont.fontSize;
	}, [device, gatheringName]);

	return fontSize;
};
export default useGatheringNameFontSize;
